import React, { useContext, useEffect, useState, useRef } from "react";
import { CSSTransition } from "react-transition-group";
import {
  useSearchParams,
  useNavigate,
  useLocation,
  Link,
} from "react-router-dom";
import "./MultiStepForm.css"; // فایل CSS برای انیمیشن‌ها
import { PatternFormat } from "react-number-format";
import _ from "lodash";
import ServiceStorage from "../../../core/services/service.storage";
import ContextApp from "../../../core/contexts/context.app";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import loginImage from "../../../assets/images/login2.svg";
import { Button, Col, Container, Row } from "react-bootstrap";
import {
  IconCall,
  IconCategory,
  IconCheck,
  IconChevronLeft,
  IconClipBoard,
  IconHome,
  IconIranFlag,
  IconUserCheck,
  IconUserProfile,
  IconWallet,
} from "../../../assets/icons";
import { isMobile } from "react-device-detect";
import ApiAuth from "../../../core/api/api.auth";
import { useForm, Controller } from "react-hook-form";
import { BasketHelper } from "../../../core/utils/BasketHelper";
import ReCAPTCHA from "react-google-recaptcha";
import DottedLoadingData from "../DottedLoadingData";
import LoadingDottedButton from "../LoadingDottedButton";
import CustomOtpInput from "./Components/CustomOtpInput";
import { tools } from "../../../core/utils/tools";

const persianNumeral = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
const englishNumeral = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
function formatPhoneNumber(value) {
  // Convert Persian digits to English
  let normalized = value.replace(
    /[۰-۹]/g,
    (char) => englishNumeral[persianNumeral.indexOf(char)]
  );

  // Remove all non-digit characters
  let cleaned = normalized.replace(/\D/g, "");

  // Apply "### ### ####" format
  let match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);

  if (!match) return value;

  // Format number with spaces
  let formatted = [match[1], match[2], match[3]].filter(Boolean).join(" ");
  return formatted;
  // Convert back to Persian for display (Optional)
  // return formatted.replace(/\d/g, (d) => persianNumeral[Number(d)]);
}

const LoginRegister = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  let location = useLocation();

  const ctx = useContext(ContextApp);
  const [timeForSendCod, setTimeForSendCod] = useState(0); // timer for get agine cod
  // set timer
  useEffect(() => {
    let myInterval = setInterval(() => {
      if (timeForSendCod > 0) {
        setTimeForSendCod(timeForSendCod - 1);
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  });
  const [currentStep, setCurrentStep] = useState(
    ctx.isAuth && _.isEmpty(ctx.userInfo?.name) ? 3 : 1
  );
  const {
    watch,
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    setFocus,
  } = useForm();
  const phoneNumberWatch = "0" + watch("phoneNumber");
  const [loadingBtnMobile, setLoadingBtnMobile] = useState(false);
  const [loadingBtnVerifyCode, setLoadingBtnVerifyCode] = useState(false);
  const [loadingBtnRegister, setLoadingBtnRegister] = useState(false);
  const [loadingBtnResendCode, setLoadingBtnResendCode] = useState(false);
  const [isCaptchaRequired, setIsCaptchaRequired] = useState(false);
  const recaptcha = useRef();
  useEffect(() => {
    (async () => {
      try {
        if (ctx.isAuth) {
          // اول لیست افراد وابسطه به این کاربر اپدیت بشه
          const basketPersonList = await BasketHelper.getBasketPersonList(ctx);
          //ادغام و دریافت اخرین سبد خرید فعال
          const basket5 = await BasketHelper.getBasket(ctx);
        }
        if (currentStep == 1) {
          setFocus("phoneNumber");
        } else if (currentStep == 2) {
          setFocus("verifyCode");
        } else if (currentStep == 3) {
          setFocus("firstName");
        } else if (currentStep == 4 && !_.isNil(searchParams.get("r"))) {
          navigate("../" + searchParams.get("r"), {
            state: { prevPath: location.pathname },
          });
        }
      } catch (error) {}
    })();
    return () => {};
  }, [currentStep]);
  useEffect(() => {
    if (
      ctx.isAuth &&
      !_.isEmpty(ctx.userInfo) &&
      !_.isEmpty(ctx.userInfo?.name)
    )
      navigate("/profile");
    getIsCaptchaRequired();
  }, []);

  async function getIsCaptchaRequired() {
    try {
      var result = await ApiAuth.isCaptchaRequired();
      setIsCaptchaRequired(result);
    } catch {
      setIsCaptchaRequired(true);
    }
  }

  const onSubmitGetPhoneNumber = async (data) => {
    setTimeForSendCod(0);
    try {
      const captchaValue = isCaptchaRequired
        ? recaptcha.current.getValue()
        : "";
      if (isCaptchaRequired && !captchaValue) {
        toast.error(
          "لطفا صحت اعتبار سنجی گوگل را انجام دهید. جهت این کار بر روی من روبات نیستم کلیک کنید.",
          {
            duration: 10000,
            position: "top-right",
          },
          { style: { marginTop: "55px" } }
        );

        return;
      }
      if (!_.isEmpty(data.phoneNumber)) {
        setLoadingBtnMobile(true);
        setLoadingBtnVerifyCode(false);
        setLoadingBtnRegister(false);
        setLoadingBtnResendCode(false);

        const result = await ApiAuth.login({
          phoneNumber: "0" + data.phoneNumber,
          captchaValue: captchaValue,
        });
        setLoadingBtnMobile(false);

        if (result.succeeded == true) {
          setCurrentStep(2); // برو به مرحله سوم
          toast.success(result.message, { style: { marginTop: "55px" } });
          setTimeForSendCod(60);
          // بستن مدال نمایش شماره تلفن و باز کردن دریافت کد 4 رقمی
          //  props.setManageComponent({ ...props.manageComponent, modalId: 2, mobile: phoneNumber });
        } else {
          // recaptcha.current.reset();
          toast.error(result.message, { style: { marginTop: "55px" } });
        }
      } else
        toast.error("لطفا شماره موبایل را وارد نمایید", {
          style: { marginTop: "55px" },
        });
    } catch (error) {
      setLoadingBtnMobile(false);
    }
  };
  const props = {};
  const onSubmitVerifyCode = async (data) => {
    if (_.isEmpty(data.verifyCode)) {
      toast.error("لطفا کد تایید چهار رقمی را وارد نمایید.", {
        style: { marginTop: "55px" },
      });
      return;
    }
    setTimeForSendCod(0);
    setLoadingBtnVerifyCode(true);
    setLoadingBtnRegister(false);
    setLoadingBtnResendCode(false);
    const phoneNumberSpan = "0" + data.phoneNumber;
    const result = await ApiAuth.verifyMobile({
      phoneNumber: "0" + data.phoneNumber,
      token: data.verifyCode,
    });
    if (result.succeeded == false || result.data == null) {
      toast.error(result.message, { style: { marginTop: "55px" } });
      setLoadingBtnVerifyCode(false);
      setLoadingBtnResendCode(false);
    } else {
      if (
        result.succeeded == true &&
        result.data != null &&
        result.data.jwToken != null
      ) {
        ServiceStorage.setToken(result.data.jwToken, result.data.refreshToken);

        ServiceStorage.setUserInfo({
          name: result.data.name,
          phone: result.data.userName,
          email: result.data.email,
          walletRiallBalance: result.data.walletRiallBalance,
          walletAvailableRiallBalance: result.data.walletAvailableRiallBalance,
          basketCount: result.data.basketCount,
        });

        ctx.setUserInfo({
          name: result.data.name,
          phone: result.data.userName,
          email: result.data.email,
          walletRiallBalance: result.data.walletRiallBalance,
          walletAvailableRiallBalance: result.data.walletAvailableRiallBalance,
          basketCount: result.data.basketCount,
        });

        ctx.setIsAuth(true);

        if (_.isEmpty(result.data.name)) {
          setCurrentStep(3); // برو به مرحله سوم
        } else {
          setCurrentStep(4); // برو به مرحله سوم
        }
      } else {
        recaptcha.current.reset();
      }
    }
  };
  const onSubmitSaveUserInfo = async (data) => {
    setLoadingBtnRegister(true);
    try {
      const result = await ApiAuth.updateUserSite(data);

      if (result.succeeded == true) {
        //تکمیل اطلاعات کاربر
        let userInfo = ServiceStorage.getUserInfo();
        userInfo.name = data.firstName + " " + data.lastName;
        //تکمیل اطلاعات کاربر
        ServiceStorage.setUserInfo(userInfo);
        ctx.setUserInfo(userInfo);
        // await BasketHelper.getBasketPersonList(ctx);

        toast.success(data.firstName + " " + data.lastName + " خوش آمدید", {
          style: { marginTop: "55px" },
        });
        setCurrentStep(4); // برو به مرحله سوم
      }
    } catch (error) {
    } finally {
    }
  };
  const handlePrevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const resendCode = async (phoneNumberWatch) => {
    setTimeForSendCod(0);
    setLoadingBtnResendCode(true);
    const captchaValue = "";
    try {
      if (!_.isEmpty(phoneNumberWatch)) {
        setLoadingBtnVerifyCode(false);

        const result = await ApiAuth.login({
          phoneNumber: phoneNumberWatch,
          captchaValue: captchaValue,
        });

        if (result.succeeded === true) {
          toast.success(result.message, { style: { marginTop: "55px" } });
          setTimeForSendCod(60);
          setLoadingBtnResendCode(false);
        } else {
          toast.error(result.message, { style: { marginTop: "55px" } });
          setLoadingBtnResendCode(false);
        }
      } else toast.error("لطفا شماره موبایل را وارد نمایید");
    } catch (error) {
      setLoadingBtnMobile(false);
      setLoadingBtnResendCode(false);
    }
  };
  return isMobile ? (
    <>
      {/******* حالت موبایل *********************/}
      {/* <ToastContainer
        position="top-center"
        rtl="true"
        style={{ marginTop: "55px" }}
      /> */}
      <Container>
        <Row>
          <Col className="my-auto text-center">
            <div className="multi-step-form position-relative  rounded-5 pt-4">
              <div className="large-icons text-center pt-4 position-relative">
                <IconUserProfile />
                {ctx.isAuth && (
                  <div className="position-absolute bg-success rounded-circle check-user">
                    <IconCheck fillColor="#fff" />
                  </div>
                )}
                {!ctx.isAuth ? (
                  <div className="text-secondary mt-2">ورود / ثبت نام </div>
                ) : (
                  <div className="text-secondary mt-2">
                    <div className="my-1">{ctx.userInfo.name} </div>
                    {ctx.userInfo.phone}
                  </div>
                )}
              </div>
              <CSSTransition
                in={currentStep === 1}
                timeout={300}
                classNames="step"
                unmountOnExit
              >
                <form
                  onSubmit={handleSubmit(onSubmitGetPhoneNumber)}
                  className="multiForm"
                >
                  <h2> وارد کردن شماره موبایل </h2>
                  <div className="text-secondary fs-09 pt-1">
                    برای ورود یا ثبت نام شماره موبایل خود را وارد کنید
                  </div>
                  <div className="text-secondary fs-075 mt-1">
                    کدی چهار رقمی به شماره موبایل شما ارسال خواهد شد
                  </div>
                  <div className="form-control border-secondary-subtle ltr text-center mt-4 ">
                    <div className="d-flex justify-content-center">
                      <div className="d-flex align-items-center me-1">
                        <IconIranFlag />
                      </div>
                      {/* bg-light-blue */}
                      <div className="d-flex justify-content-center align-items-center text-dark px-2  rounded-pill">
                        +98
                      </div>
                      <Controller
                        control={control}
                        name="phoneNumber"
                        render={({ field }) => (
                          <input
                            type="tel"
                            maxlength="12"
                            autoFocus="true"
                            style={{ border: "none", outline: "none" }}
                            onChange={(e) => {
                              let formatted = formatPhoneNumber(e.target.value);
                              if (formatted.length > 1) {
                                e.target.value =
                                  formatted.charAt(0) == 0
                                    ? formatted.replace(/^0+/, "")
                                    : formatted;
                              } else {
                                e.target.value = formatted;
                              }
                              setValue(
                                "phoneNumber",
                                e.target.value.replaceAll(" ", "")
                              );
                            }}
                          />
                        )}
                      />
                    </div>
                  </div>
                  <div>
                    {isCaptchaRequired && (
                      <ReCAPTCHA
                        className="mt-2"
                        ref={recaptcha}
                        hl={"fa"}
                        sitekey={process.env.REACT_APP_Recaptcha_SITE_KEY}
                      />
                    )}
                    {!loadingBtnMobile ? (
                      <button
                        type="submit"
                        className="btn btn-primary mt-2 px-4"
                      >
                        ارسال کد
                      </button>
                    ) : (
                      <button
                        disabled
                        type="submit"
                        className="btn btn-primary mt-2 px-4"
                      >
                        <LoadingDottedButton btnText="ارسال کد" />
                      </button>
                    )}
                  </div>
                </form>
              </CSSTransition>

              <CSSTransition
                in={currentStep === 2}
                timeout={300}
                classNames="step"
                unmountOnExit
              >
                <form
                  onSubmit={handleSubmit(onSubmitVerifyCode)}
                  className="multiForm"
                >
                  <h2> وارد کردن کد تایید </h2>
                  <div className="text-secondary fs-09 pt-1">
                    کد تایید چهار رقمی را وارد نمایید
                  </div>
                  <div className="text-secondary fs-075 mt-1">
                    این کد به شماره موبایل
                    <span className="fw-bold text-black px-1">
                      {phoneNumberWatch}
                    </span>
                    ارسال شده است
                  </div>
                  <div className=" mt-4 ">
                    <Controller
                      control={control}
                      name="verifyCode"
                      render={({ field }) => (
                        <PatternFormat
                          lang="en"
                          autofocus="true"
                          getInputRef={field.ref}
                          className="form-control border-secondary-subtle text-center ltr w-100"
                          format="  #    #    #    #  "
                          mask="-"
                          // mask="  -  "
                          placeholder="  -    -    -    -  "
                          onValueChange={(value) => {
                            // تبدیل اعداد به انگلیسی با استفاده از تابع toEnDigit
                            const formattedValue = tools.toEnDigit(
                              value.formattedValue
                            );
                            // حذف تمام فاصله‌ها
                            const cleanedValue = formattedValue.replace(
                              /\s+/g,
                              ""
                            );
                            // ارسال مقدار به field.onChange بدون فاصله‌ها
                            field.onChange(cleanedValue);
                          }}
                          // onValueChange={(value) => {
                          //   field.onChange(value.value);
                          // }}
                          style={{ width: "230px" }}
                          onBlur={field.onBlur}
                        />
                      )}
                    />
                  </div>
                  <div className="d-flex mt-2  justify-content-between">
                    {!loadingBtnVerifyCode ? (
                      <button type="submit" className="btn btn-primary w-60">
                        تایید
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className="btn btn-primary  w-60"
                        disabled
                      >
                        {/* <span
                          className="spinner-border spinner-border-sm me-2"
                          role="state"
                          aria-hidden="true"
                        ></span> */}
                        <LoadingDottedButton btnText="تایید" />
                      </button>
                    )}

                    <button
                      className="btn btn-outline-primary ms-2  w-40"
                      type="button"
                      onClick={handlePrevStep}
                    >
                      مرحله قبلی
                    </button>
                  </div>
                  <div className="mt-4  fs-085">
                    در صورتی که پیامک حاوی کد تایید دریافت ننموده اید می توانید
                    از لینک زیر جهت ارسال مجدد کد اقدام نمایید
                  </div>
                  <Col xs="12" className="d-flex justify-content-center ">
                    {/* <Button variant='none' size='sm' className="  rounded t-3  py-1  " onClick={timeForSendCod > 0 ? handleNothing : registerUser}  > */}
                    {!loadingBtnResendCode ? (
                      <Button
                        variant="success"
                        size="sm"
                        className="px-4 mt-2"
                        disabled={timeForSendCod > 0 ? "disabled" : ""}
                        onClick={() => resendCode(phoneNumberWatch)}
                      >
                        <span> ارسال کد </span>
                        {timeForSendCod > 0 ? (
                          <span
                            className="d-inline-block"
                            style={{ width: "20px" }}
                          >
                            {timeForSendCod}{" "}
                          </span>
                        ) : (
                          " "
                        )}
                      </Button>
                    ) : (
                      <Button
                        variant="success"
                        className="px-4  mt-2"
                        size="sm"
                        disabled
                      >
                        <LoadingDottedButton btnText="ارسال کد" />
                      </Button>
                    )}
                  </Col>
                </form>
              </CSSTransition>

              <CSSTransition
                in={currentStep === 3}
                timeout={300}
                classNames="step"
                unmountOnExit
              >
                <form
                  onSubmit={handleSubmit(onSubmitSaveUserInfo)}
                  className="multiForm"
                >
                  <h2>تکمیل اطلاعات</h2>

                  <div className="text-secondary fs-09">
                    لازم به ذکر است جهت ثبت سفارش ثبت اطلاعات ذیل الزامی میباشد
                  </div>
                  <div className="text-secondary fs-09">
                    لطفا نام و نام خانوادگی خود را وارد کنید
                  </div>
                  <div className="mt-4  justify-content-center">
                    <Controller
                      control={control}
                      name="firstName"
                      rules={{ required: "لطفاً نام را وارد کنید" }} // شرط اجباری بودن
                      render={({ field, fieldState }) => (
                        <>
                          <input
                            {...field}
                            type="text"
                            name="firstName"
                            placeholder="نام"
                            className="form-control border-secondary-subtle mx-auto"
                            style={{ width: "220px" }}
                          />
                          {fieldState.error && (
                            <div className="text-danger mt-1">
                              {fieldState.error.message}
                            </div>
                          )}
                        </>
                      )}
                    />
                  </div>

                  <div className="mt-2   justify-content-center">
                    <Controller
                      control={control}
                      name="lastName"
                      rules={{ required: "لطفاً نام خانوادگی را وارد کنید" }} // شرط اجباری بودن
                      render={({ field, fieldState }) => (
                        <>
                          <input
                            {...field}
                            type="text"
                            name="lastName"
                            placeholder="نام خانوادگی"
                            className="form-control border-secondary-subtle mx-auto"
                            style={{ width: "220px" }}
                          />
                          {fieldState.error && (
                            <div className="text-danger mt-1">
                              {fieldState.error.message}
                            </div>
                          )}
                        </>
                      )}
                    />
                  </div>
                  <div className="mt-2 d-flex  justify-content-center">
                    {!loadingBtnRegister ? (
                      <button type="submit" className="btn btn-primary px-3">
                        ثبت اطلاعات
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className="btn btn-primary px-3"
                        disabled
                      >
                        {/* <span
                          className="spinner-border spinner-border-sm me-2"
                          role="state"
                          aria-hidden="true"
                        ></span>
                        ثبت اطلاعات */}
                        <LoadingDottedButton btnText="ثبت اطلاعات" />
                      </button>
                    )}

                    {/* <button
                      type="button"
                      className="btn btn-outline-primary ms-2"
                      onClick={handlePrevStep}
                    >
                      مرحله قبلی
                    </button> */}
                  </div>
                </form>
              </CSSTransition>
              <CSSTransition
                in={currentStep === 4}
                timeout={300}
                classNames="step"
                unmountOnExit
              >
                <>
                  <div className="text-success fs-075">
                    با موفقیت وارد شدید.
                  </div>
                  {!_.isNil(searchParams.get("r")) ? (
                    <div className="mt-4">
                      <div>در حال انتقال به صفحه پرداخت </div>
                      <div>لطفا منتظر بمانید ... </div>
                      <DottedLoadingData withText="false" />
                    </div>
                  ) : (
                    <div className=" small-svg pb-5 mt-2">
                      <div className="text-center fs-075 text-muted">
                        شما می توانید از منوی زیر برای دسترسی سریع استفاده
                        نمایید.
                      </div>
                      <Link to="/" className="mt-2 d-block">
                        <div className="border bg-white rounded-3 p-2 d-flex align-items-center justify-content-between fs-08 text-dark text-start">
                          <div>
                            <IconHome fillColor="#000" /> صفحه اصلی
                            <div className="fs-065 text-muted">
                              مشاهده صفحه اصلی سایت تفریحان
                            </div>
                          </div>
                          <div>
                            <IconChevronLeft fillColor="#444" />
                          </div>
                        </div>
                      </Link>
                      <Link
                        to={
                          ctx.selectedCity?.englishName === undefined
                            ? "/c"
                            : `/c/${ctx.selectedCity?.englishName}`
                        }
                        className="mt-2 d-block"
                      >
                        <div className="border bg-white rounded-3 p-2 d-flex align-items-center justify-content-between fs-08 text-dark text-start">
                          <div>
                            <IconCategory fillColor="#000" /> لیست تفریحات
                            <div className="fs-065 text-muted">
                              مشاهده و سفارش تفریحات قابل رزرو
                            </div>
                          </div>
                          <div>
                            <IconChevronLeft fillColor="#444" />
                          </div>
                        </div>
                      </Link>
                      <Link to="/order" className="mt-2 d-block">
                        <div className="border bg-white rounded-3 p-2 d-flex align-items-center justify-content-between fs-08 text-dark text-start">
                          <div>
                            <IconClipBoard fillColor="#000" /> سفارش های من
                            <div className="fs-065 text-muted">
                              مشاهده و دانلود بلیط تفریحاتی که رزرو کرده اید
                            </div>
                          </div>
                          <div>
                            <IconChevronLeft fillColor="#444" />
                          </div>
                        </div>
                      </Link>
                      <Link to="/profile" className="mt-2 d-block">
                        <div className="border bg-white rounded-3 p-2 d-flex align-items-center justify-content-between fs-08 text-dark text-start">
                          <div>
                            <IconUserCheck fillColor="#000" /> حساب کاربری
                            <div className="fs-065 text-muted">
                              مشاهده پروفایل شما در تفریحان
                            </div>
                          </div>
                          <div>
                            <IconChevronLeft fillColor="#444" />
                          </div>
                        </div>
                      </Link>
                      <Link to="/wallet" className="mt-2 d-block">
                        <div className="border bg-white rounded-3 p-2 d-flex align-items-center justify-content-between fs-08 text-dark text-start">
                          <div>
                            <IconWallet fillColor="#000" /> کیف پول
                            <div className="fs-065 text-muted">
                              مشاهده کیف پول شما در تفریحان
                            </div>
                          </div>
                          <div>
                            <IconChevronLeft fillColor="#444" />
                          </div>
                        </div>
                      </Link>
                      <Link to="/contact" className="mt-2 d-block mb-5">
                        <div className="border bg-white rounded-3 p-2 d-flex align-items-center justify-content-between fs-08 text-dark text-start">
                          <div>
                            <IconCall fillColor="#000" /> تماس با پشتیبانی
                            <div className="fs-065 text-muted">
                              مشاهده شماره تلفن های مجموعه تفریحان
                            </div>
                          </div>
                          <div>
                            <IconChevronLeft fillColor="#444" />
                          </div>
                        </div>
                      </Link>
                    </div>
                  )}
                </>
              </CSSTransition>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  ) : (
    <>
      {/******* حالت دستکتاپ *********************/}
      {/* <ToastContainer position="top-right" rtl="true" /> */}
      <Container fluid className="">
        <Container>
          <Row>
            <Col
              md="12"
              lg
              className="my-auto text-center justify-content-center align-items-center d-flex pb-md-5 pb-xl-0"
            >
              <div className="multi-step-form position-relative  rounded-5 pt-4">
                <div className="large-icons text-center pt-4 position-relative">
                  <IconUserProfile />
                  {ctx.isAuth ? (
                    <div className="position-absolute bg-success rounded-circle check-user">
                      <IconCheck fillColor="#fff" />
                    </div>
                  ) : (
                    ""
                  )}
                  {!ctx.isAuth ? (
                    <div className="text-secondary mt-2">ورود / ثبت نام </div>
                  ) : (
                    <div className="text-secondary mt-2">
                      <div>{ctx.userInfo.name} </div>
                      {ctx.userInfo.phone}
                    </div>
                  )}
                </div>
                <CSSTransition
                  in={currentStep === 1}
                  timeout={300}
                  classNames="step"
                  unmountOnExit
                >
                  <form
                    onSubmit={handleSubmit(onSubmitGetPhoneNumber)}
                    className="multiForm"
                  >
                    <h2> وارد کردن شماره موبایل </h2>
                    <div className="text-secondary fs-09 pt-1">
                      برای ورود یا ثبت نام شماره موبایل خود را وارد کنید
                    </div>
                    <div className="text-secondary fs-075 mt-1">
                      کدی چهار رقمی به شماره موبایل شما ارسال خواهد شد
                    </div>
                    <div className="form-control border-secondary-subtle ltr text-center mt-4 ">
                      <div className="d-flex justify-content-start">
                        <div className="d-flex align-items-center me-1">
                          <IconIranFlag />
                        </div>
                        <div className="d-flex justify-content-center align-items-center text-dark px-2 ms-1 rounded-pill">
                          +98
                        </div>
                        <Controller
                          control={control}
                          name="phoneNumber"
                          render={({ field }) => (
                            <input
                              type="tel"
                              maxlength="12"
                              autoFocus="true"
                              style={{ border: "none", outline: "none" }}
                              onChange={(e) => {
                                let formatted = formatPhoneNumber(
                                  e.target.value
                                );
                                if (formatted.length > 1) {
                                  e.target.value =
                                    formatted.charAt(0) == 0
                                      ? formatted.replace(/^0+/, "")
                                      : formatted;
                                } else {
                                  e.target.value = formatted;
                                }
                                setValue(
                                  "phoneNumber",
                                  e.target.value.replaceAll(" ", "")
                                );
                              }}
                            />
                          )}
                        />
                      </div>
                    </div>
                    <div>
                      {isCaptchaRequired && (
                        <ReCAPTCHA
                          className="mt-2"
                          ref={recaptcha}
                          hl={"fa"}
                          sitekey={process.env.REACT_APP_Recaptcha_SITE_KEY}
                        />
                      )}
                      {!loadingBtnMobile ? (
                        <button
                          type="submit"
                          className="btn btn-primary mt-2 px-4"
                        >
                          ارسال کد
                        </button>
                      ) : (
                        <button
                          disabled
                          type="submit"
                          className="btn btn-primary mt-2 px-4"
                        >
                          {/* <span
                            className="spinner-border spinner-border-sm me-2"
                            role="state"
                            aria-hidden="true"
                          ></span>
                          ارسال کد */}
                          <LoadingDottedButton btnText="ارسال کد" />
                        </button>
                      )}
                    </div>
                  </form>
                </CSSTransition>

                <CSSTransition
                  in={currentStep === 2}
                  timeout={300}
                  classNames="step"
                  unmountOnExit
                >
                  <form
                    onSubmit={handleSubmit(onSubmitVerifyCode)}
                    className="multiForm"
                  >
                    <h2> وارد کردن کد تایید </h2>
                    <div className="text-secondary fs-09 pt-1">
                      کد تایید چهار رقمی را وارد نمایید
                    </div>
                    <div className="text-secondary fs-075 mt-1">
                      این کد به شماره موبایل
                      <span className="fw-bold text-black px-1">
                        {phoneNumberWatch}
                      </span>
                      ارسال شده است
                    </div>
                    <div className=" mt-3 d-flex justify-content-center">
                      <Controller
                        control={control}
                        name="verifyCode"
                        render={({ field }) => (
                          <PatternFormat
                            autofocus="true"
                            getInputRef={field.ref}
                            className="form-control border-secondary-subtle text-center ltr"
                            format="  #    #    #    #  "
                            mask="-"
                            // mask="  -  "
                            placeholder="  -    -    -    -  "
                            onValueChange={(value) => {
                              field.onChange(value.value);
                            }}
                            onBlur={field.onBlur}
                          />
                        )}
                      />
                    </div>
                    <div className="d-flex mt-2  justify-content-between">
                      {!loadingBtnVerifyCode ? (
                        <button type="submit" className="btn btn-primary w-60">
                          تایید
                        </button>
                      ) : (
                        <button
                          type="submit"
                          className="btn btn-primary  w-60"
                          disabled
                        >
                          {/* <span
                            className="spinner-border spinner-border-sm me-2"
                            role="state"
                            aria-hidden="true"
                          ></span>
                          تایید */}
                          <LoadingDottedButton btnText="تایید" />
                        </button>
                      )}

                      <button
                        className="btn btn-outline-primary ms-2  w-40"
                        type="button"
                        onClick={handlePrevStep}
                      >
                        مرحله قبلی
                      </button>
                    </div>
                    <div className="mt-4  fs-085">
                      در صورتی که پیامک حاوی کد تایید دریافت ننموده اید می
                      توانید از لینک زیر جهت ارسال مجدد کد اقدام نمایید
                    </div>
                    <Col xs="12" className="d-flex justify-content-center ">
                      {/* <Button variant='none' size='sm' className="  rounded t-3  py-1  " onClick={timeForSendCod > 0 ? handleNothing : registerUser}  > */}
                      {!loadingBtnResendCode ? (
                        <Button
                          variant="success"
                          className="px-4  mt-2"
                          size="sm"
                          disabled={timeForSendCod > 0 ? "disabled" : ""}
                          onClick={() => resendCode(phoneNumberWatch)}
                        >
                          <span> ارسال کد </span>

                          {timeForSendCod > 0 ? (
                            <span
                              className="d-inline-block"
                              style={{ width: "20px" }}
                            >
                              {timeForSendCod}{" "}
                            </span>
                          ) : (
                            " "
                          )}
                        </Button>
                      ) : (
                        <Button
                          variant="success"
                          className="px-4  mt-2"
                          size="sm"
                          disabled
                        >
                          {/* <span
                            className="spinner-border spinner-border-sm me-2"
                            role="state"
                            aria-hidden="true"
                          ></span>
                          ارسال کد */}
                          <LoadingDottedButton btnText="ارسال کد" />
                        </Button>
                      )}
                    </Col>
                  </form>
                </CSSTransition>

                <CSSTransition
                  in={currentStep === 3}
                  timeout={300}
                  classNames="step"
                  unmountOnExit
                >
                  <form
                    onSubmit={handleSubmit(onSubmitSaveUserInfo)}
                    className="multiForm"
                  >
                    <h2>تکمیل اطلاعات</h2>

                    <div className="text-secondary fs-09">
                      لازم به ذکر است جهت ثبت سفارش ثبت اطلاعات ذیل الزامی
                      میباشد
                    </div>
                    <div className="text-secondary fs-09">
                      لطفا نام و نام خانوادگی خود را وارد کنید
                    </div>
                    <div className="mt-4   justify-content-center">
                      <Controller
                        control={control}
                        name="firstName"
                        rules={{ required: "لطفاً نام را وارد کنید" }} // شرط اجباری بودن
                        render={({ field, fieldState }) => (
                          <>
                            <input
                              {...field}
                              type="text"
                              name="firstName"
                              placeholder="نام"
                              className="form-control border-secondary-subtle  mx-auto"
                              style={{ width: "220px" }}
                            />
                            {fieldState.error && (
                              <div className="text-danger mt-1">
                                {fieldState.error.message}
                              </div>
                            )}
                          </>
                        )}
                      />
                    </div>
                    <div className="mt-2   justify-content-center">
                      <Controller
                        control={control}
                        name="lastName"
                        rules={{ required: "لطفاً نام خانوادگی را وارد کنید" }} // شرط اجباری بودن
                        render={({ field, fieldState }) => (
                          <>
                            <input
                              {...field}
                              type="text"
                              name="lastName"
                              placeholder="نام خانوادگی"
                              className="form-control border-secondary-subtle mx-auto"
                              style={{ width: "220px" }}
                            />
                            {fieldState.error && (
                              <div className="text-danger mt-1">
                                {fieldState.error.message}
                              </div>
                            )}
                          </>
                        )}
                      />
                    </div>
                    <div className="mt-2 d-flex  justify-content-center">
                      {!loadingBtnRegister ? (
                        <button type="submit" className="btn btn-primary px-3">
                          ثبت اطلاعات
                        </button>
                      ) : (
                        <button
                          type="submit"
                          className="btn btn-primary px-3"
                          disabled
                        >
                          {/* <span
                            className="spinner-border spinner-border-sm me-2"
                            role="state"
                            aria-hidden="true"
                          ></span>
                          ثبت اطلاعات */}
                          <LoadingDottedButton btnText="ثبت اطلاعات" />
                        </button>
                      )}
                      {/* <button
                      type="button"
                      className="btn btn-outline-primary ms-2"
                      onClick={handlePrevStep}
                    >
                      مرحله قبلی
                    </button> */}
                    </div>
                  </form>
                </CSSTransition>
                <CSSTransition
                  in={currentStep === 4}
                  timeout={300}
                  classNames="step"
                  unmountOnExit
                >
                  <>
                    <div className="text-success fs-075">
                      با موفقیت وارد شدید.
                    </div>
                    {!_.isNil(searchParams.get("r")) ? (
                      <div className="mt-4">
                        <div>در حال انتقال به صفحه پرداخت </div>
                        <div>لطفا منتظر بمانید ... </div>
                        <DottedLoadingData withText="false" />
                      </div>
                    ) : (
                      <div className=" small-svg pb-5 mt-2">
                        <div className="text-center fs-075 text-muted mb-2">
                          شما می توانید از منوی زیر برای دسترسی سریع استفاده
                          نمایید.
                        </div>
                        <Row className="gx-2">
                          <Col lg="6" xl="4">
                            <Link to="/" className="mt-2 d-block">
                              <div className="border bg-white rounded-3 p-2 d-flex align-items-center justify-content-between fs-08 text-dark text-start">
                                <div>
                                  <IconHome fillColor="#000" /> صفحه اصلی
                                  <div className="fs-065 text-dark opacity-60 mt-2">
                                    مشاهده صفحه اصلی سایت تفریحان
                                  </div>
                                </div>
                              </div>
                            </Link>
                          </Col>
                          <Col lg="6" xl="4">
                            <Link
                              to={
                                ctx.selectedCity?.englishName === undefined
                                  ? "/c"
                                  : `/c/${ctx.selectedCity?.englishName}`
                              }
                              className="mt-2 d-block"
                            >
                              <div className="border bg-white rounded-3 p-2 d-flex align-items-center justify-content-between fs-08 text-dark text-start">
                                <div>
                                  <IconCategory fillColor="#000" /> لیست تفریحات
                                  <div className="fs-065 text-dark opacity-60 mt-2">
                                    مشاهده و سفارش تفریحات قابل رزرو
                                  </div>
                                </div>
                              </div>
                            </Link>
                          </Col>
                          <Col lg="6" xl="4">
                            <Link to="/order" className="mt-2 d-block">
                              <div className="border bg-white rounded-3 p-2 d-flex align-items-center justify-content-between fs-08 text-dark text-start">
                                <div>
                                  <IconClipBoard fillColor="#000" /> سفارش های
                                  من
                                  <div className="fs-065 text-dark opacity-60 mt-2">
                                    مشاهده و دانلود بلیط تفریحاتی که رزرو کرده
                                    اید
                                  </div>
                                </div>
                              </div>
                            </Link>
                          </Col>
                          <Col lg="6" xl="4">
                            <Link to="/profile" className="mt-2 d-block">
                              <div className="border bg-white rounded-3 p-2 d-flex align-items-center justify-content-between fs-08 text-dark text-start">
                                <div>
                                  <IconUserCheck fillColor="#000" /> حساب کاربری
                                  <div className="fs-065 text-dark opacity-60 mt-2">
                                    مشاهده پروفایل شما در تفریحان
                                  </div>
                                </div>
                              </div>
                            </Link>
                          </Col>
                          <Col lg="6" xl="4">
                            <Link to="/wallet" className="mt-2 d-block">
                              <div className="border bg-white rounded-3 p-2 d-flex align-items-center justify-content-between fs-08 text-dark text-start">
                                <div>
                                  <IconWallet fillColor="#000" /> کیف پول
                                  <div className="fs-065 text-dark opacity-60 mt-2">
                                    مشاهده کیف پول شما در تفریحان
                                  </div>
                                </div>
                              </div>
                            </Link>
                          </Col>
                          <Col lg="6" xl="4">
                            <Link to="/contact" className="mt-2 d-block mb-5">
                              <div className="border bg-white rounded-3 p-2 d-flex align-items-center justify-content-between fs-08 text-dark text-start">
                                <div>
                                  <IconCall fillColor="#000" /> تماس با پشتیبانی
                                  <div className="fs-065 text-dark opacity-60 mt-2">
                                    مشاهده شماره تلفن های مجموعه تفریحان
                                  </div>
                                </div>
                              </div>
                            </Link>
                          </Col>
                        </Row>
                      </div>
                    )}
                  </>
                </CSSTransition>
              </div>
            </Col>
            <Col lg="5" className="d-none d-lg-block">
              <img src={loginImage} alt="" />
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  );
};

export default LoginRegister;
